"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FromUndergroundTime = require("./FromUndergroundTime");
Object.keys(_FromUndergroundTime).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FromUndergroundTime[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FromUndergroundTime[key];
    }
  });
});